




































































































































































































































































































import AppraisalResponseCard from "@/components/appraisal/AppraisalResponseCard.vue";
import ClearanceApprovalResponseCard from "@/components/clearance-approval/ClearanceApprovalResponseCard.vue";
import ClearanceResponseCard from "@/components/clearance-approval/ClearanceResponseCard.vue";
import CompanySheet from "@/components/company/CompanySheet.vue";
import SnapshotDetail from "@/components/handover/SnapshotDetail.vue";
import ActivityTimeLineItemDocumentCard from "@/components/partner/ActivityTimeLineItemDocumentCard.vue";
import ActivityTimeLineItemSignedCard from "@/components/partner/ActivityTimeLineItemSignedCard.vue";
import PartnerReportMapAddress from "@/components/partner/report/v2/PartnerReportMapAddress.vue";
import PartnerReportRepairInfo from "@/components/partner/report/v2/repair/PartnerReportRepairInfo.vue";
import PartnerReportTowingCard from "@/components/partner/report/v2/towing/PartnerReportTowingCard.vue";
import ReportBaseTimeLine from "@/components/partner/ReportBaseTimeLine.vue";
import SharedContentAccessDescription from "@/components/partner/SharedContentAccessDescription.vue";
import SharedContentAccessExpired from "@/components/partner/SharedContentAccessExpired.vue";
import SharedContentVehicleCard from "@/components/partner/SharedContentVehicleCard.vue";
import SharedContentContactCard from "@/components/partner/SharedContentContactCard.vue";
import RentalResponseCard from "@/components/rental/RentalResponseCard.vue";
import RepairEstimateResponseCard from "@/components/repair-estimate/RepairEstimateResponseCard.vue";
import MSelect from "@/components/utility/mmmint/MSelect.vue";
import TimelineCard from "@/components/utility/TimelineItem.vue";
import Tooltip from "@/components/utility/tooltip.vue";
import LayoutReportFullWidth from "@/layouts/LayoutReportFullWidth.vue";
import { AttachmentRequestStatusEnum } from "@/lib/enum/attachment-request-status.enum";
import { DigitalSignatureRequestStatusEnum } from "@/lib/enum/digital-signature-request-status.enum";
import { RefDocumentType } from "@/lib/shared-content/RefDocument";
import { FetchStrategyRegistry, SharedContentFetchService } from "@/lib/shared-content/SharedContentFetchStrategy";
import {
  AttachmentRequestFetchStrategy,
  ClearanceApprovalFetchStrategy,
  ClearanceFetchStrategy,
  DocumentFetchStrategy,
  RentalFetchStrategy,
  RepairEstimateFetchStrategy,
  ReportFetchStrategy,
  SignFetchStrategy,
  SnapshotFetchStrategy
} from "@/lib/shared-content/strategies";
import { AppraisalFetchStrategy } from "@/lib/shared-content/strategies/AppraisalFetchStrategy";
import { detailedDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { IRepairEstimate } from "@/models/repair-estimate.entity";
import { Report } from "@/models/report.entity";
import sharedContentService from "@/services/mrfiktiv/services/sharedContentService";
import {
  MrfiktivAttachmentResponseViewModelGen,
  MrfiktivReportViewModelGen,
  MrfiktivSharedContentViewmodelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { SignDigitalSignatureRequestSignerViewModelGen } from "@/services/sign/v1/data-contracts";
import { BackendResourceEnum, FrontendResourceEnum, ResourceEnum } from "@/store/enum/authResourceEnum";
import { CoverageTypeEnum } from "@/store/enum/coverage-type.enum";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue } from "vue-property-decorator";
import MTextField from "@/components/utility/mmmint/MTextField.vue";

type SharedDocument = {
  refDocument: RefDocumentType;
  refType: string;
  refId: string;
};

@Component({
  components: {
    LayoutReportFullWidth,
    ReportBaseTimeLine,
    Tooltip,
    TimelineCard,
    SharedContentAccessDescription,
    SharedContentAccessExpired,
    ActivityTimeLineItemDocumentCard,
    SnapshotDetail,
    RepairEstimateResponseCard,
    RentalResponseCard,
    ClearanceApprovalResponseCard,
    ClearanceResponseCard,
    AppraisalResponseCard,
    ActivityTimeLineItemSignedCard,
    PartnerReportRepairInfo,
    CompanySheet,
    PartnerReportTowingCard,
    PartnerReportMapAddress,
    MSelect,
    SharedContentVehicleCard,
    SharedContentContactCard,
    MTextField
  },
  filters: {
    detailedDate
  }
})
class SharedContentView extends Vue {
  loading = false;

  expired = false;

  isExpand = false;

  sharedContent: MrfiktivSharedContentViewmodelGen | null = null;

  sharedDocuments: SharedDocument[] = [];

  get isCompleted() {
    return this.attachmentRequest?.status === AttachmentRequestStatusEnum.COMPLETED;
  }
  /**
   * Dont offer print option if we share anything but a report - only show print button for reports
   */
  get hidePrint() {
    const isReportSharing = this.sharedDocuments.find(d => d.refType === BackendResourceEnum.REPORT);

    return !isReportSharing;
  }

  get ResourceEnum() {
    return ResourceEnum;
  }

  get FrontendResourceEnum() {
    return FrontendResourceEnum;
  }

  get accessToken() {
    return this.$route.params.token;
  }

  get partner() {
    return ReportModule.partner;
  }

  get user() {
    return this.sharedContent?.user;
  }

  get companyName() {
    return this.partner.companyName;
  }

  get color() {
    return this.partner.settings?.color ?? "primary";
  }

  get showTowing() {
    if (this.report?.towing?.length) {
      return true;
    }
    return false;
  }

  get coverageTypeItems() {
    return Object.values(CoverageTypeEnum).map(value => ({
      value,
      text: this.$t(`enums.CoverageTypeEnum.${value}`)
    }));
  }

  get attachmentRequest(): MrfiktivAttachmentResponseViewModelGen | undefined {
    return this.sharedDocuments?.find(
      sd =>
        sd.refType === ResourceEnum.ATTACHMENT_REQUEST &&
        (sd.refDocument as MrfiktivAttachmentResponseViewModelGen).status !== AttachmentRequestStatusEnum.COMPLETED
    )?.refDocument as MrfiktivAttachmentResponseViewModelGen;
  }

  get attachmentRequestId() {
    return this.sharedDocuments?.find(
      sd =>
        sd.refType === ResourceEnum.ATTACHMENT_REQUEST &&
        (sd.refDocument as MrfiktivAttachmentResponseViewModelGen).status !== AttachmentRequestStatusEnum.COMPLETED
    )?.refId;
  }

  get requests() {
    const checkList: { refId: string; refType: BackendResourceEnum; isDone: boolean }[] = [];
    this.sharedDocuments.forEach(r => {
      if (r.refType === ResourceEnum.REPAIR_ESTIMATE) {
        const isDone = (r.refDocument as IRepairEstimate).isCompleted;
        checkList.push({ refId: r.refId, refType: r.refType, isDone: isDone });
      }
    });
    return checkList;
  }

  get signRequests(): SignDigitalSignatureRequestSignerViewModelGen[] | undefined {
    return this.sharedDocuments
      ?.filter(sd => sd.refType === ResourceEnum.SIGN)
      .map(v => v.refDocument as SignDigitalSignatureRequestSignerViewModelGen)
      .filter(sr => sr.status !== DigitalSignatureRequestStatusEnum.SIGNED);
  }

  get report(): MrfiktivReportViewModelGen | undefined {
    const report = this.sharedDocuments?.find(sd => sd.refType === ResourceEnum.REPORT)
      ?.refDocument as MrfiktivReportViewModelGen;
    return new Report(report);
  }

  get showSubmitData() {
    return this.attachmentRequest;
  }

  async mounted() {
    this.loading = true;
    this.expired = false;

    try {
      // Fetch shared content
      this.sharedContent = await sharedContentService.access(this.partner.id, this.accessToken);

      const registry = new FetchStrategyRegistry();

      registry.register(new ReportFetchStrategy());
      registry.register(new DocumentFetchStrategy());
      registry.register(new SnapshotFetchStrategy());
      registry.register(new RepairEstimateFetchStrategy());
      registry.register(new SignFetchStrategy());
      registry.register(new AttachmentRequestFetchStrategy());
      registry.register(new ClearanceApprovalFetchStrategy());
      registry.register(new ClearanceFetchStrategy());
      registry.register(new AppraisalFetchStrategy());
      registry.register(new RentalFetchStrategy());

      const fetchService = new SharedContentFetchService(registry);
      const results = await fetchService.fetchContent(this.partner.id, this.sharedContent, this.accessToken);

      // Filter out null documents and preserve order
      this.sharedDocuments = results
        .filter(doc => doc.refDocument !== null)
        .map(result => ({
          refDocument: result.refDocument,
          refType: result.refType,
          refId: result.refId
        }));
    } catch (e) {
      if ((e as any).message === "Sharing document expired") {
        this.expired = true;
      } else {
        handleError(e);
      }
    } finally {
      this.loading = false;
    }
  }

  print() {
    window.print();
  }

  startAttachmentRequest() {
    if (!this.attachmentRequestId) {
      return undefined;
    }

    this.$router.push({
      name: "ReportDataResponse",
      params: {
        accessToken: this.accessToken
      }
    });
  }

  startSignRequest(signRequestId: string) {
    this.$router.push({
      name: "DigitalSignature",
      params: {
        signRequestId
      }
    });
  }

  /**
   * Summarizes a description text to a maximum character length
   * @param description The full description text
   * @param maxLength Maximum number of characters to display (default: 150)
   * @returns Truncated description with ellipsis if needed
   */
  summarizeDescription(description: string, maxLength = 150): string {
    if (!description) {
      return "";
    }
    if (description.length <= maxLength) {
      return description;
    }

    return description.substring(0, maxLength) + "...";
  }
}
export default SharedContentView;
